<template>
  <header class="site-header">
    <div class="header-inner">
      <router-link to="/" class="brand">
        <img :src="logo" alt="湖南瑞祥智航" class="brand-logo-img" />
        <span class="brand-name">湖南瑞祥智航</span>
      </router-link>
      <nav class="nav">
        <router-link
          v-for="item in navs"
          :key="item.to"
          :to="item.to"
          class="nav-link"
          :class="{ active: isActive(item.to) }"
        >{{ item.text }}</router-link>
      </nav>
      <div class="header-right">
        <router-link to="/tools" class="btn btn-primary btn-sm">🤖 AI助手</router-link>
        <router-link to="/register" class="btn btn-outline btn-sm">登录/注册</router-link>
        </div>
    </div>
  </header>
</template>

<script>
import logo from '../assets/wz_logo.svg'

export default {
  name: 'SiteHeader',
  data() {
    return {
      logo,
      navs: [
        { to: '/', text: '首页' },
        { to: '/jobs', text: '找工作' },
        { to: '/talents', text: '找人才' },
        { to: '/policies', text: '政策文件' },
        { to: '/tools', text: 'AI助手' }
      ]
    }
  },
  methods: {
    isActive(to) {
      if (to === '/') return this.$route.path === '/'
      return this.$route.path.startsWith(to)
    }
  }
}
</script>

<style scoped>
.brand-logo-img { height: 40px; width: auto; display: block; }
</style>
